import clsx from 'clsx'
import {FC} from 'react'
import {usePageData} from 'src/app/context/PageDataContext'
import GBreadcrumbs from '../../Libs/Breadcrumbs/GBreadcrumbs'
import { Typography } from '../../Display'

const DefaultTitle: FC = () => {
  const {pageTitle} = usePageData()

  return (
    <div data-testid='breadcrumbs-component'>
      <div className={clsx('mb-0 flex items-start flex-col')}>
        {pageTitle && (
          <Typography variant='h6' className='font-medium'>
            {pageTitle}
          </Typography>
        )}

        <GBreadcrumbs />
      </div>
    </div>
  )
}

export {DefaultTitle}
